import { createTheming } from "@callstack/react-theme-provider";
import { themes } from "./themes"; // Your theme definitions

// Initialize theming utilities
const { ThemeProvider, withTheme, useTheme } = createTheming(themes.green); // Default theme is "green"

// Export the utilities
export { ThemeProvider, withTheme, useTheme };
